import React, { useEffect, useRef, useState } from 'react'
import { connect } from 'react-redux'
import {
  Row,
  Col,
  Form,
  Input,
  DatePicker,
  Button,
  Modal,
  Card,
  Layout,
  Typography,
  Image,
  message,
} from 'antd'
import '../../css/patient.add.scss'
import util from '../../util/util'
import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input/input'
import 'react-phone-number-input/style.css'
import { deleteAccountRequest } from '../../store/action/patient.action'
import moment from 'moment'

import { CheckOutlined, ExclamationCircleFilled } from '@ant-design/icons'
import TurnstileWidget from '../common/turnstile.widget'
import Text from 'antd/lib/typography/Text'
import logo from '../../logo.png'

const AccountDeleteForm = (props) => {
  const [form] = Form.useForm()
  const [registerPatientError, setRegisterPatientError] = useState(false)
  const [status, setStatus] = useState({ submitted: false, cancelled: false })
  const [recapcha, setRecapcha] = useState(false)
  const capchaResetRef = useRef(null)
  const capchaTokenRef = useRef(null)

  // Prefer the token the callback gave us; fall back to asking Turnstile
  // directly. The callback is the only link in this chain we don't control, and
  // if it silently fails to fire the user gets a form that cannot be submitted
  // and no explanation. Reading the widget at submit time removes that whole
  // failure mode.
  const currentCaptchaToken = () =>
    recapcha || (capchaTokenRef.current ? capchaTokenRef.current() : null)
  const { Title } = Typography

  // (an empty useEffect holding a commented-out reCAPTCHA executeAsync() call
  // lived here — removed with the Turnstile migration; the widget renders and
  // issues its token on its own)

  const dateFormatList = [
    'MM/DD/YYYY',
    'MM/DD/YY',
    'MM-DD-YYYY',
    'MM-DD-YY',
    'MMDDYYYY',
    'MMDDYY',
  ]

  //   var showConfirmBox = (value) => {

  //       Modal.confirm({
  //         title:
  //           "Do you want to reschedule regimen (Exercise and Measurements) with surgery date?",
  //         icon: <ExclamationCircleFilled />,
  //         content: "",
  //         okText: "Yes",
  //         cancelText: "No",
  //         onOk: () => handleFormSubmit({ ...value, regimEdit: true }),
  //         onCancel: () => handleFormSubmit(value),
  //       });
  //   };
  const onFinishFailed = ({ errorFields }) => {
    if (!props.isRegistration) return
    setRegisterPatientError(true)
    setTimeout(() => {
      setRegisterPatientError(false)
    }, 5000)
  }
  var handleFormSubmit = async (value) => {
    // Turnstile renders on mount and delivers its token via callback, so by
    // submit time we either have one or the user has not completed the check.
    // The old invisible-reCAPTCHA flow executed the challenge HERE and awaited
    // it — which is what hung forever when the site key was invalid.
    const token = currentCaptchaToken()
    if (!token) {
      message.error('Please complete the security check and try again.')
      return
    }
    props.setLoading(true)

    var patObj = {
      firstname: value.firstname,
      lastname: value.lastname,
      dob: value.dob.format('MM/DD/YYYY'),
      email: value.email,
      phone: value.phone,
      token: token,
    }

    const res = await props.deleteAccount(patObj)
    if (res) {
      setStatus({ submitted: true, cancelled: false })
      form.resetFields()
    }
    // Turnstile tokens are single use. Reset whether or not the request
    // succeeded, or a retry after a failure is rejected server-side with a
    // message that points at the captcha rather than the real cause.
    if (capchaResetRef.current) capchaResetRef.current()
    props.setLoading(false)
  }

  // (the old reCAPTCHA onChange handler lived here — TurnstileWidget calls
  // setRecapcha directly via its onToken prop)

  const renderForm = () => {
    return (
      <>
        <Form
          form={form}
          layout={'vertical'}
          onFinish={handleFormSubmit}
          onFinishFailed={onFinishFailed}
        >
          <Row justify='center' gutter={50}>
            <Col md={12} xs={24} gutter={25} style={{ marginBottom: 10 }}>
              <fieldset className='fieldsetContainer'>
                <Row gutter={25}>
                  <Col style={{ width: '100%' }}>
                    <center>
                      <Image
                        src={logo}
                        height={80}
                        style={{ marginTop: 10 }}
                      ></Image>
                      &nbsp;
                      <h2 style={{ marginTop: 20 }}>DELETE ACCOUNT REQUEST</h2>
                    </center>
                  </Col>
                  <Col gutter={50} style={{ marginBottom: 10 }}>
                    {' '}
                    <Text strong>
                      You as the user of the MoveAI Health App can request that
                      your account information which may include your Name,
                      Phone Number, Email and Date of Birth, be removed along
                      with all the associated data from your account which
                      includes exercises, questionnaires responses and any
                      measurements values. In order for your account and data to
                      be deleted please complete the following form:
                    </Text>
                  </Col>
                  <Col md={12} xs={24}>
                    <Form.Item
                      label='First Name'
                      name='firstname'
                      rules={[
                        {
                          required: true,
                          whitespace: true,
                          message: 'Please enter patient first name.',
                        },
                      ]}
                    >
                      <Input maxLength={40} />
                    </Form.Item>
                  </Col>
                  <Col md={12} xs={24}>
                    <Form.Item
                      label='Last Name'
                      name='lastname'
                      rules={[
                        {
                          required: true,
                          whitespace: true,
                          message: 'Please enter patient last name.',
                        },
                      ]}
                    >
                      <Input maxLength={40} />
                    </Form.Item>
                  </Col>
                  <Col md={12} xs={24}>
                    <Form.Item
                      label='Email (optional but preferred)'
                      name='email'
                      rules={[
                        {
                          required: false,
                          whitespace: true,
                          message: 'Please enter valid email',
                          type: 'email',
                        },
                      ]}
                    >
                      <Input maxLength={50} />
                    </Form.Item>
                  </Col>
                  <Col md={12} xs={24}>
                    <Form.Item
                      label='Registered Phone Number'
                      name='phone'
                      rules={[
                        {
                          required: true,
                          whitespace: true,
                          message: 'Please enter patient cell number.',
                        },
                        () => ({
                          validator(rule, value) {
                            var number = value
                              ? value.charAt(0) == '+'
                                ? value
                                : '+1' + value
                              : ''
                            if (!value || isValidPhoneNumber(number)) {
                              return Promise.resolve()
                            }
                            return Promise.reject('Please enter valid number!')
                          },
                        }),
                      ]}
                    >
                      <PhoneInput
                        addInternationalOption={false}
                        defaultCountry='US'
                        className='phone-input fullWidth'
                        enableAreaCodes
                      />
                    </Form.Item>
                  </Col>
                  <Col md={12} xs={24}>
                    <Form.Item
                      label='Date of Birth'
                      name='dob'
                      rules={[
                        {
                          required: true,
                          message: 'Please enter patient birth date.',
                        },
                      ]}
                    >
                      <DatePicker
                        suffixIcon={null}
                        allowClear={false}
                        placeholder='MM/DD/YYYY'
                        format={dateFormatList}
                        showToday={false}
                        disabledDate={(current) => {
                          return current >= moment().add(-1, 'days')
                        }}
                        style={{ width: '100%' }}
                        defaultPickerValue={moment().add(-50, 'years')}
                      />
                    </Form.Item>
                  </Col>

                  <Row>
                    <Col>
                      <TurnstileWidget
                        onToken={setRecapcha}
                        resetRef={capchaResetRef}
                        tokenRef={capchaTokenRef}
                      />
                    </Col>
                  </Row>
                </Row>
              </fieldset>
            </Col>
          </Row>
          <Row justify='center'>
            <Col>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  gap: '20px',
                  paddingBottom: 50,
                }}
              >
                <Button
                  type='primary'
                  onClick={() => {
                    form.resetFields()
                    setStatus({ submitted: false, cancelled: true })
                  }}
                  className='submit-form-button'
                >
                  Cancel
                </Button>
                <Button
                  type='primary'
                  htmlType='submit'
                  className='submit-form-button'
                  //disabled={!recapcha}
                >
                  Submit
                </Button>
              </div>
            </Col>
          </Row>
        </Form>
      </>
    )
  }

  const cancelledMessage = () => {
    return (
      <Row className='thankyou'>
        <Col>
          <Card style={{ textAlign: 'center' }}>
            <Title level={4}>Your request was cancelled.</Title>
          </Card>
        </Col>
      </Row>
    )
  }

  const renderThankYou = () => {
    return (
      <Row className='thankyou'>
        <Col>
          <Card
            title={
              <>
                <Row justify='center' flex='100%'>
                  <CheckOutlined className='check-circle' />
                </Row>
                <Row justify='center'>
                  <Title level={1}>Thank You!</Title>
                </Row>
              </>
            }
            style={{ textAlign: 'center' }}
          >
            <Title level={4}>
              Thank you for your submission. Based on the information submitted,
              if authenticated, your account and data will be deleted after 90
              days.
            </Title>
          </Card>
        </Col>
      </Row>
    )
  }

  return (
    <>
      {(status.submitted || status.cancelled) && (
        <center>
          <Image src={logo} height={80} style={{ marginTop: 30 }}></Image>
        </center>
      )}
      <Col className='patientAddContainer ' style={{ marginTop: 20 }}>
        {status.submitted ? (
          <Col className='patientRegistrationContainer'>
            {' '}
            {renderThankYou()}
          </Col>
        ) : status.cancelled ? (
          <Col className='patientRegistrationContainer'>
            {cancelledMessage()}
          </Col>
        ) : (
          renderForm()
        )}
      </Col>
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    token: util.verifyToken(state.profile.token),
    isLoading: state.profile.isLoading,
    customer: state.profile.customer,
    surgeons: state.surgeon.surgeons,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    deleteAccount: (patient, id) => dispatch(deleteAccountRequest(patient, id)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AccountDeleteForm)
